import * as React from "react"

function parseQuerystring() {
    const keyValueMap: {[id: string]: string} = {}
    window.location.search?.split("?")?.[1]?.split("&")
        .forEach(keyValue => {
            const [key, value] = keyValue.split("=")
            keyValueMap[key] = value
        })
    return keyValueMap
}

export class FileUpload extends React.Component<{}> {
    handleSubmit(e: any) {
        e.preventDefault()
        const files = (document.querySelector('[name=file]') as any)?.files
        const formData = new FormData()
        formData.append("csv", files[0])
        const querystring = parseQuerystring()

        fetch("/api/upload-csv", {
            method: "POST",
            body: formData,
            headers: {
                token: querystring.token
            }
        })

    }

    render() {
        return <form method="POST" encType="multipart/form-data" onSubmit={this.handleSubmit}>
            <input type="file" name="file" />
            <button type="submit">Upload File</button>
        </form>
    }
}